import { IScoreBarProperties } from "../../properties/BarProperties";

const ScoreBar = ({ score, className, size }: IScoreBarProperties) => {
  const getProgressBarColor = (score: number) => {
    if (score >= 70) return "bar-fill-green";
    if (score >= 30) return "bar-fill-orange";
    return "bar-fill-red";
  };

  const getTextColor = (score: number) => {
    if (score >= 70) return "bar-txt-green";
    if (score >= 30) return "bar-txt-orange";
    return "bar-txt-red";
  };

  return (
    <div className={`bar-score-row ${className}`}>
      <div
        className={`bar-score-track ${
          size === "large"
            ? "bar-h-lg"
            : size === "medium"
            ? "bar-h-md"
            : size === "small"
            ? "bar-h-sm"
            : "bar-h-md"
        }`}
      >
        <div
          className={`bar-score-fill ${getProgressBarColor(score)}`}
          style={{ width: `${score}%` }}
        />
      </div>
      <span className={`bar-score-pct ${getTextColor(score)}`}>
        {score.toFixed(1)}%
      </span>
    </div>
  );
};

export default ScoreBar;
